import { isTrueish } from '@/helpers/StringHelpers'
import tenant from '@/helpers/Tenant'
import { TenantConfig } from '@/types/TenantConfig'

/**
 * Use the same sizes for each type of image to reduce data use and increase cache hits.
 */

export function teaserImageUrl(event: EventWithMeta): string | undefined {
  const { width, height } = teaserImageSize()
  return isTrueish(event.meta.no_cropping)
    ? imageUrl(event.meta.image_profile, width * 2)
    : imageUrl(event.meta.image_profile, width * 2, height * 2)
}

export function tenantTeaserImageSize(tenant: TenantConfig): Record<'width' | 'height', number> {
  // Most tenants have teasers that are 272x216px, an aspect ratio of 4:5.
  const width = tenant.teaserImageSize?.width || 272
  const height = tenant.teaserImageSize?.height || 216
  return { width, height }
}

export function teaserImageSize() {
  return tenantTeaserImageSize(tenant)
}

export function coverImageUrl(event) {
  // TODO Make size configurable per tenant?
  return imageUrl(event.meta.image_cover, 1500)
}

export function imageUrlMaxWidth(url: string) {
  return imageUrl(url, 1500)
}

export function cartItemImageUrl(event: EventWithMeta): string | undefined {
  const width = 64
  const height = 51
  return isTrueish(event.meta.no_cropping) ? undefined : imageUrl(event.meta.image_profile, width * 2, height * 2)
}

export function imageUrl(apiUrl: string, width: number, height?: number) {
  if (apiUrl) {
    // Use a relative URL to load the image from the CDN instead of the API.
    // Also replace the path prefix from /v1/ to /api/ to request via the tix-web API proxy.
    const path = apiUrl.replace(/^https?:\/\/.*?\/v1\//, '/api/')

    const parameters = {
      sizex: width,
      sizey: height,
    }

    const queryString = Object.entries(parameters)
      .filter(([, value]) => Boolean(value))
      .map(([name, value]) => `${name}=${value}`)
      .join('&')

    return path + '?shrinkonly&' + queryString
  }
}
